import type { AxiosError } from 'axios';

import type { SearchWithinState } from '@/components/ChatBot/hooks';
import type {
  AskNeedlResponseType,
  IntermediateStepType,
} from '@/features/ChatBotV2/hooks/useAskNeedl';
import type { FeedItemType } from '@/types';

export type AttachmentStatusType =
  | 'COMPLETED'
  | 'PENDING'
  | 'PROCESSING_ERROR'
  | 'PROCESSING'
  | 'UPLOADED'
  | 'UPLOADING_ERROR'
  | 'UPLOADING';

export type AttachmentType = {
  id: string;
  name: string;
  mime_type: string;
  file: File;
  file_type: string;
  bucket?: string;
  key?: string;
  status: AttachmentStatusType;
  progress?: number;
  error?: string;
  delete?: boolean;
  deleted?: boolean;
};

export type MetadataType = {
  type:
    | 'channel'
    | 'document'
    | 'feed'
    | 'home'
    | 'needl_universe'
    | 'report'
    | 'source';
  channel_id?: string;
  board_id?: string;
  document_id?: string;
  source?: string;
  document?: FeedItemType;
  report_id?: string;
};

export type SessionState = {
  sessionId?: string;
  messages: Message[];
  attachments?: AttachmentType[];
  attachmentsFeedId?: string;
  promptEnabled?: boolean;
  metadata: MetadataType;
};

export type UserMessageState = {
  type: 'user';
  prompt: string;
  id: string;
  botMessageId: string;
  attachments?: AttachmentType[];
};

export type BotMessageState = {
  type: 'bot';
  formattedData: string;
  intermediateSteps: IntermediateStepType[];
  data: AskNeedlResponseType;
  prompt: string;
  id: string;
  error?: AxiosError;
  streamingAnswer?: string;
  answerMarkdown?: string;
  generatingStopped?: boolean;
  pro?: boolean;
};

export type Message = BotMessageState | UserMessageState;

export const isBotMessageState = (
  message: Message
): message is BotMessageState => message.type === 'bot';

export const isUserMessageState = (
  message: Message
): message is UserMessageState => message.type === 'user';

export type ChatPanelType = {
  searchWithin: SearchWithinState;
};
